export function headerSearch() {
    const openSearchBtn = document.querySelector('.open-search-button');
    const headerSearch = document.querySelector('.header-search');

    if (openSearchBtn) {
        openSearchBtn.addEventListener('click', function () {
            headerSearch.classList.add('search-active');
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerSearch.js